module.exports = __webpack_public_path__ + "static/media/export.3610e431.svg";